import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { FloorPlanItemState } from './floor-plan-item.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'floorPlanItem', resettable: true, idKey: 'id' })
export class FloorPlanItemStore extends EntityStore<FloorPlanItemState> {
  constructor() {
    super();
  }
}
